import React, { useEffect, useState } from "react";
import "../css/CookieConsent.css";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("cookie-consent");

    if (!saved) {
      setShow(true);
    } else {
      const savedDate = new Date(JSON.parse(saved).date);
      const now = new Date();

      const diffMonths =
        (now.getFullYear() - savedDate.getFullYear()) * 12 +
        (now.getMonth() - savedDate.getMonth());

      if (diffMonths >= 6) setShow(true);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem(
      "cookie-consent",
      JSON.stringify({ choice, date: new Date() })
    );
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner">
      <p>
        Web sitemiz deneyiminizi geliştirmek için çerezleri kullanmaktadır.
        <a href="/cookie-policy" className="cookie-link"> Çerez Politikasını Görüntüle</a>
      </p>

      <div className="cookie-buttons">
        <button className="accept" onClick={() => handleChoice("accepted")}>
          Kabul Et
        </button>
        <button className="reject" onClick={() => handleChoice("rejected")}>
          Reddet
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
